import React from "react";
import { Provider } from "react-redux";
import { UseReduxProvider } from "assets/scripts/hooks/useRedux";
import { UseQuickPayProvider } from "assets/scripts/components/containers/public/QuickPay/useQuickPayContext";
const StoreProvider = ({ store, children }) => (<Provider store={store}>
		<UseReduxProvider value={store}>
			<UseQuickPayProvider>
				{children}
			</UseQuickPayProvider>
		</UseReduxProvider>
	</Provider>);
export default StoreProvider;



// WEBPACK FOOTER //
// ./src/assets/scripts/components/containers/StoreProvider.tsx